var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-1031, -4634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1031, 4634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F3F3F3",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-phone-1147912",
    transform: "translate(17.094, 16.2828) rotate(10) translate(-17.094, -16.2828)translate(9.094, 9.2828)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4428407,10.4227194 L11.3756801,9.05244191 C10.9448992,8.85881575 10.4107307,8.96307599 10.1177997,9.29075103 L8.99776911,10.5418739 C7.8949698,10.035467 7.06787031,9.54395448 6.10292091,8.70987254 C5.06904655,7.81621333 4.51764689,7.08639164 3.96624723,6.16294378 L5.39644009,5.19481296 C5.77552736,4.94160952 5.89614604,4.47988559 5.67213992,4.10752759 L4.08686591,1.4712329 C3.81116608,1.00950897 3.1219165,0.860565771 2.62221056,1.14355786 L0.675080519,2.27552619 C0.227068296,2.54362396 -0.0314002934,2.99045357 0.00306218523,3.45217749 C0.0375246639,3.92879574 0.106449621,4.53946287 0.244299536,4.95650384 C0.812930434,6.84808251 2.17419834,8.79923846 4.10409715,10.452508 C6.01676471,12.1057776 8.27405706,13.2824289 10.4624245,13.7888357 C10.9448992,13.893096 11.65138,13.9526733 12.2200109,13.9973562 C12.7714105,14.0271449 13.3055789,13.8037301 13.59851,13.4015834 L14.8736217,11.6887366 C15.1493216,11.241907 14.9597779,10.6610285 14.4428407,10.4227194 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40371765,5.19505914 C9.71848165,5.28096909 10.0332457,5.452789 10.2764724,5.71051886 C10.5340066,5.96824872 10.705696,6.26893355 10.7915407,6.58393671 C10.863078,6.84166657 11.1063047,7.01348648 11.3781464,6.99916815 L11.4353762,6.99916815 C11.80737,6.98484982 12.0792116,6.62689169 11.9790595,6.26893355 C11.8359849,5.75347383 11.5641433,5.25233244 11.1492271,4.85141933 C10.7343109,4.43618789 10.2478575,4.16413971 9.73278911,4.02095645 C9.37510274,3.92072817 9.01741638,4.19277636 9.00310893,4.56505282 L9.00310893,4.62232612 C8.97449402,4.88005598 9.14618347,5.12346751 9.40371765,5.19505914 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60373101,3.23067898 C9.55245117,3.37452027 10.4666724,3.74850763 11.1911496,4.35264106 C11.9328763,4.97115861 12.3813622,5.71913333 12.5366073,6.51026044 C12.6056051,6.79794303 12.9160954,7.01370497 13.278334,6.99932084 L13.3300824,6.99932084 C13.7613188,6.98493671 14.071809,6.65410173 13.9855617,6.30888263 C13.7613188,5.27322533 13.1748372,4.28072041 12.2261171,3.47520917 C11.2601475,2.66969793 10.0871844,2.18063754 8.82797396,2.00802799 C8.41398698,1.95049147 8.01724946,2.2094058 8,2.5546249 L8,2.59777729 C8,2.91422813 8.25874186,3.17314246 8.60373101,3.23067898 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9945907,6.30712838 C15.7468472,4.76403032 14.954068,3.27861817 13.5997369,2.09605703 C12.2454058,0.913495903 10.5442337,0.221264997 8.77699675,0.00494283839 C8.38060715,-0.0383215932 8.01725001,0.206843519 8.00073378,0.56738045 L8.00073378,0.625066358 C7.98421755,0.942338857 8.24847728,1.20192545 8.59531818,1.24518988 C10.065263,1.4182476 11.4691428,2.00952817 12.5922467,2.99018862 C13.7153505,3.97084907 14.3759999,5.21109611 14.5907109,6.48018611 C14.6402596,6.78303713 14.9375518,7.01378076 15.3009089,6.99935929 L15.3669739,6.99935929 C15.7468472,6.97051633 16.0441394,6.65324383 15.9945907,6.30712838 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGrey);
export default __webpack_public_path__ + "static/media/phone-icon--grey.1a66425ba50b9d6730986e5541037848.svg";
export { ForwardRef as ReactComponent };